(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fe-product-assist"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fe-product-assist')) {
  customElements.define('fe-product-assist', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.info = document.getElementById(`ProductInfo-${this.dataset.section}-${this.dataset.product}`);
      if (!this.info) return;
      const signal = this.controller.signal;
      this.mediaQuery = window.matchMedia('(max-width: 989px)');
      this.sync = () => {
        const bounds = this.info.getBoundingClientRect();
        const buttons = [...this.info.querySelectorAll('form[data-type="add-to-cart-form"] button[name="add"]')];
        const buttonVisible = buttons.some(button => {
          if (!button.getClientRects().length) return false;
          const box = button.getBoundingClientRect();
          return box.bottom > 0 && box.top < window.innerHeight;
        });
        const modalOpen = document.documentElement.classList.contains('overflow-hidden') || document.body.classList.contains('overflow-hidden') || document.querySelector('dialog[open],[aria-modal="true"][open]');
        this.hidden = !this.mediaQuery.matches || bounds.top > 120 || (!this.hasAttribute('data-journey') && bounds.bottom < 0) || buttonVisible || !!modalOpen;
        const price = this.querySelector('[data-fe-assist-price]');
        const total = this.info.querySelector('[data-fe-total]')?.textContent;
        if (price && total && price.textContent !== total) price.textContent = total;
        // The arrow must point towards the customization, not always upwards.
        if (this.hasAttribute('data-journey')) {
          const firstStage = this.info.querySelector('[data-fe-stage="colors"]') || this.info.querySelector('[data-fe-stage="photos"]') || this.info.querySelector('.gpo-app,variant-picker');
          const isAbove = firstStage ? firstStage.getBoundingClientRect().top > window.innerHeight * 0.45 : true;
          const arrow = this.querySelector('[data-fe-options-arrow]');
          const label = this.querySelector('[data-fe-options-label]');
          const button = this.querySelector('[data-fe-options]');
          if (arrow) arrow.textContent = isAbove ? '↓' : '↑';
          if (label && button) label.textContent = isAbove ? button.dataset.fePersonalizeLabel : button.dataset.feEditLabel;
        }
      };
      let scheduled = false;
      window.addEventListener('scroll', () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => { this.sync(); scheduled = false; });
      }, { passive: true, signal });
      window.addEventListener('resize', this.sync, { passive: true, signal });
      document.addEventListener('click', () => requestAnimationFrame(this.sync), { signal });
      this.info.addEventListener('fe:summary-updated', this.sync, { signal });
      this.querySelector('[data-fe-options]').addEventListener('click', () => {
        const target = this.info.querySelector('[data-fe-stage="colors"]') || this.info.querySelector('.gpo-app,variant-picker') || this.info;
        const top = target.getBoundingClientRect().top + window.scrollY - 110;
        window.scrollTo({ top: Math.max(0, top), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        const input = target.querySelector('input:not([type="hidden"]):not([disabled]),select,button');
        if (input) input.focus({ preventScroll: true });
      }, { signal });
      this.sync();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fe-variant-selection-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fe-variant-selection-preview')) {
    customElements.define('fe-variant-selection-preview', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        this.root = this.closest('product-info');
        this.picker = this.root?.querySelector('variant-picker');
        this.form = document.getElementById(this.dataset.productForm);
        this.variants = Array.from(this.querySelectorAll('[data-fe-preview-variant]'));
        this.title = this.querySelector('[data-fe-preview-title]');

        if (!this.picker || !this.variants.length) return;

        this.picker.addEventListener('change', () => this.schedule(), true);
        this.root?.addEventListener('variant:change', (event) => {
          const variantId = event.detail?.variant?.id;
          if (variantId && this.showById(String(variantId))) return;
          this.schedule();
        });

        const selectedVariant = this.picker.querySelector('[data-selected-variant]');
        if (selectedVariant) {
          this.observer = new MutationObserver(() => this.schedule());
          this.observer.observe(selectedVariant, { childList: true, characterData: true, subtree: true });
        }

        this.schedule();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      schedule() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          requestAnimationFrame(() => this.sync());
        });
      }

      sync() {
        const values = Array.from(this.picker.querySelectorAll('input[data-option-index]:checked'))
          .sort((a, b) => Number(a.dataset.optionIndex || 0) - Number(b.dataset.optionIndex || 0))
          .map((input) => input.value);

        if (values.length) {
          const key = values.join('||');
          const match = this.variants.find((variant) => variant.dataset.fePreviewOptions === key);
          if (match) {
            this.show(match);
            return;
          }
        }

        const formVariantId = this.form?.querySelector('[name="id"]')?.value;
        if (formVariantId) this.showById(String(formVariantId));
      }

      showById(id) {
        const match = this.variants.find((variant) => variant.dataset.fePreviewVariant === id);
        if (!match) return false;
        this.show(match);
        return true;
      }

      show(match) {
        this.variants.forEach((variant) => {
          variant.hidden = variant !== match;
        });
        if (this.title) this.title.textContent = match.dataset.fePreviewTitle || '';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fe-mobile-product-gallery')) {
    customElements.define('fe-mobile-product-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        this.track = this.querySelector('[data-fe-mobile-track]');
        this.slides = Array.from(this.querySelectorAll('[data-fe-mobile-slide]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-fe-mobile-thumb]'));
        this.dialog = this.querySelector('[data-fe-mobile-dialog]');
        this.dialogTrack = this.querySelector('[data-fe-dialog-track]');
        this.dialogSlides = Array.from(this.querySelectorAll('[data-fe-dialog-slide]'));
        this.mainFrame = null;
        this.dialogFrame = null;
        this.pointerStart = 0;
        this.suppressOpen = false;
        this.variantMedia = {};
        try {
          this.variantMedia = JSON.parse(this.querySelector('[data-fe-variant-media]')?.textContent || '{}');
        } catch (_) {
          this.variantMedia = {};
        }
        this.productForm = document.getElementById(this.dataset.productForm);
        this.productRoot = this.productForm?.closest('product-info') || this.closest('.featured-product')?.querySelector('product-info');

        const syncVariantSoon = () => {
          requestAnimationFrame(() => requestAnimationFrame(() => this.syncVariantMedia()));
        };

        this.productRoot?.addEventListener('variant:change', (event) => {
          const mediaId = event.detail?.variant?.featured_media?.id || event.detail?.variant?.featuredMedia?.id;
          if (mediaId) {
            this.scrollMainTo(String(mediaId));
            return;
          }
          syncVariantSoon();
        });

        this.productRoot?.addEventListener('change', (event) => {
          const choice = event.target?.closest?.('input[data-option-index]');
          if (choice) {
            const label = this.productRoot.querySelector(`label[for="${CSS.escape(choice.id)}"]`);
            const variantId = label?.dataset.feVariantId;
            if (variantId && this.variantMedia[String(variantId)]) {
              this.scrollMainTo(String(this.variantMedia[String(variantId)]));
            }
          }
          syncVariantSoon();
        }, true);

        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => this.scrollMainTo(thumb.dataset.feMobileThumb));
        });

        this.querySelectorAll('[data-fe-mobile-open]').forEach((button) => {
          button.addEventListener('click', () => {
            if (this.suppressOpen) return;
            this.openDialog(button.dataset.feMobileOpen);
          });
        });

        if (this.track) {
          this.track.addEventListener('scroll', () => this.scheduleMainSync(), { passive: true });
          this.track.addEventListener('pointerdown', () => {
            this.pointerStart = this.track.scrollLeft;
            this.suppressOpen = false;
          }, { passive: true });
          this.track.addEventListener('pointerup', () => {
            this.suppressOpen = Math.abs(this.track.scrollLeft - this.pointerStart) > 8;
            window.setTimeout(() => { this.suppressOpen = false; }, 0);
          }, { passive: true });
          this.track.addEventListener('pointercancel', () => {
            this.suppressOpen = false;
          }, { passive: true });
        }

        this.querySelector('[data-fe-dialog-close]')?.addEventListener('click', () => this.closeDialog());
        this.querySelector('[data-fe-dialog-prev]')?.addEventListener('click', () => this.moveDialog(-1));
        this.querySelector('[data-fe-dialog-next]')?.addEventListener('click', () => this.moveDialog(1));

        if (this.dialog) {
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.closeDialog();
          });
        }

        if (this.dialogTrack) {
          this.dialogTrack.addEventListener('scroll', () => this.scheduleDialogSync(), { passive: true });
        }

        this.syncMain();
        this.syncVariantMedia();
      }

      syncVariantMedia() {
        const variantId = this.productForm?.querySelector('[name="id"]')?.value;
        if (!variantId) return;
        const mediaId = this.variantMedia[String(variantId)];
        if (!mediaId) return;
        this.scrollMainTo(String(mediaId));
      }

      nearest(slides, scrollLeft) {
        if (!slides.length) return null;
        return slides.reduce((best, slide) => {
          const bestDistance = Math.abs(best.offsetLeft - scrollLeft);
          const distance = Math.abs(slide.offsetLeft - scrollLeft);
          return distance < bestDistance ? slide : best;
        }, slides[0]);
      }

      scheduleMainSync() {
        if (this.mainFrame) return;
        this.mainFrame = requestAnimationFrame(() => {
          this.mainFrame = null;
          this.syncMain();
        });
      }

      syncMain() {
        if (!this.track) return;
        const active = this.nearest(this.slides, this.track.scrollLeft);
        const activeId = active?.dataset.mediaId;
        this.thumbs.forEach((thumb) => {
          thumb.setAttribute('aria-current', String(thumb.dataset.feMobileThumb === activeId));
        });
      }

      scrollMainTo(mediaId) {
        const slide = this.slides.find((item) => item.dataset.mediaId === String(mediaId));
        if (!slide || !this.track) return;
        this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }

      openDialog(mediaId) {
        if (!this.dialog || !this.dialogSlides.length) return;
        if (typeof this.dialog.showModal === 'function') {
          if (!this.dialog.open) this.dialog.showModal();
        } else {
          this.dialog.setAttribute('open', '');
        }
        requestAnimationFrame(() => this.scrollDialogTo(mediaId, 'auto'));
      }

      closeDialog() {
        if (!this.dialog) return;
        if (typeof this.dialog.close === 'function' && this.dialog.open) {
          this.dialog.close();
        } else {
          this.dialog.removeAttribute('open');
        }
      }

      scrollDialogTo(mediaId, behavior = 'smooth') {
        const slide = this.dialogSlides.find((item) => item.dataset.mediaId === String(mediaId)) || this.dialogSlides[0];
        if (!slide || !this.dialogTrack) return;
        this.dialogTrack.scrollTo({ left: slide.offsetLeft, behavior });
        this.dialog.dataset.currentMedia = slide.dataset.mediaId;
      }

      scheduleDialogSync() {
        if (this.dialogFrame) return;
        this.dialogFrame = requestAnimationFrame(() => {
          this.dialogFrame = null;
          if (!this.dialogTrack) return;
          const active = this.nearest(this.dialogSlides, this.dialogTrack.scrollLeft);
          if (active) this.dialog.dataset.currentMedia = active.dataset.mediaId;
        });
      }

      moveDialog(direction) {
        if (!this.dialogSlides.length) return;
        const currentId = this.dialog?.dataset.currentMedia;
        let index = this.dialogSlides.findIndex((item) => item.dataset.mediaId === currentId);
        if (index < 0) index = 0;
        index = (index + direction + this.dialogSlides.length) % this.dialogSlides.length;
        this.scrollDialogTo(this.dialogSlides[index].dataset.mediaId);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
